import(/* webpackMode: "eager", webpackExports: ["TableFiltersNetwork"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/app/(networks)/_ui/table-filters-network.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["V3FeesTable"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/app/(networks)/(evm)/pool/v3/fees/_ui/v3-fees-table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage"] */ "/home/runner/work/dex-frontend/dex-frontend/packages/ui/dist/components/avatar.js");
;
import(/* webpackMode: "eager", webpackExports: ["List"] */ "/home/runner/work/dex-frontend/dex-frontend/packages/ui/dist/components/currency/List.js");
;
import(/* webpackMode: "eager", webpackExports: ["LinkExternal"] */ "/home/runner/work/dex-frontend/dex-frontend/packages/ui/dist/components/link.js");
